























import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ISendSmsParams } from '@/store/login/types';

const Login = namespace('login');

// 短信验证码
@Component
export default class SmsField extends Vue {
  @Login.Action('sendSms') public sendSms!: (params: ISendSmsParams) => void;
  @Login.State('loading') public loading!: boolean;

  @Model('update:modelValue') public modelValue!: string;
  @Prop() public mobile!: string;
  @Prop() public placeholder!: string;
  @Prop() public prependIcon!: string;
  @Prop() public rules!: Array<() => boolean | string>;

  public timer: any = null;
  public countdown = { time: 0, text: '' };

  public get value() {
    return this.modelValue || '';
  }

  public set value(val: string) {
    this.$emit('update:modelValue', val);
  }

  public get disabledBtn() {
    return !this.mobile || (this.countdown.time > 0);
  }

  // 发送短信验证码，并倒计时
  public onSend() {
    this.countdown = { time: 60, text: '60秒后重试' };
    this.sendSms({ mobile: this.mobile });

    this.timer = setInterval(() => {
      const time = this.countdown.time - 1;
      const text = `${time}秒后重试`;
      this.countdown = { time, text };

      if (!this.countdown.time) {
        clearInterval(this.timer);
        this.timer = null;
        this.countdown = { time: 0, text: '' };
      }
    }, 1000);
  }
}
